import { z } from 'zod'
import {
  ACCOUNT_BALANCE_VALIDATION,
  ACCOUNT_VALIDATION,
  accountBalanceRefinement,
  CASH_ADVANCE_VALIDATION,
  CITY_VALIDATION,
  CONSENT_VALIDATION,
  CREDIT_PROTECTION_VALIDATION,
  CREDIT_PULL_CONSENT_VALIDATION,
  DATE_OF_BIRTH_VALIDATION,
  EMAIL_MC_VALIDATION,
  EMAILS_VALIDATION,
  employmentDetailRefinement,
  EMPLOYMENT_VALIDATION,
  FULL_NAME_VALIDATION,
  GENERIC_VALIDATION,
  HOUSING_VALIDATION,
  INCOME_VALIDATION,
  INDUSTRY_VALIDATION,
  JOB_ROLE_VALIDATION,
  PAYMENT_METHOD_VALIDATION,
  PAYMENT_VALIDATION,
  PHONE_NUMBER_VALIDATION,
  SELF_EMPLOYMENT_DURATION_VALIDATION,
  selfEmploymentDetailRefinement,
  SSN_VALIDATION,
  STATE_VALIDATION,
  STATEMENT_VALIDATION,
  STREET_ADDRESS_VALIDATION,
  SUGGESTION_VALIDATION,
  TIME_AT_CURRENT_JOB_VALIDATION,
  UNEMPLOYMENT_DURATION_VALIDATION,
  unemploymentDetailRefinement,
  DEGREE_TYPE_VALIDATION,
  INSTITUTION_VALIDATION,
  FIELD_OF_STUDY_VALIDATION,
  studentDetailRefinement,
  JOB_COUNT_VALIDATION,
  ADDITIONAL_INCOME_SOURCES_VALIDATION,
  jobCountAndIncomeRefinement,
  BNPL_FREQUENCY_VALIDATION,
  BNPL_PURCHASE_TYPE_VALIDATION,
  BNPL_LATE_PAYMENTS_VALIDATION,
  bnplRefinement,
  RECENT_APPLICATIONS_VALIDATION,
  recentApplicationsRefinement,
  RECENT_ACCOUNTS_OPENED_VALIDATION,
  recentAccountsOpenedRefinement,
  CREDIT_REPAIR_VALIDATION,
  creditRepairRefinement,
  EDUCATION_LEVEL_VALIDATION,
  EDUCATION_FIELD_OF_STUDY_VALIDATION,
  educationRefinement,
  UNIT_VALIDATION,
  WORK_TYPE_VALIDATION,
  ZIP_CODE_VALIDATION,
} from '../../constants/schemaValidation'

const schema = z.object({
  // names are grouped together so we can validate them with superRefine
  names: FULL_NAME_VALIDATION,
  streetAddress: STREET_ADDRESS_VALIDATION,
  unit: UNIT_VALIDATION,
  city: CITY_VALIDATION,
  state: STATE_VALIDATION,
  zip: ZIP_CODE_VALIDATION,
  housing: HOUSING_VALIDATION,
  payment: PAYMENT_VALIDATION,
  dateOfBirth: DATE_OF_BIRTH_VALIDATION,
  socialSecurityNumber: SSN_VALIDATION,
  employmentStatus: EMPLOYMENT_VALIDATION,
  jobRole: JOB_ROLE_VALIDATION,
  paymentMethod: PAYMENT_METHOD_VALIDATION,
  timeAtCurrentJob: TIME_AT_CURRENT_JOB_VALIDATION,
  industry: INDUSTRY_VALIDATION,
  selfEmploymentDuration: SELF_EMPLOYMENT_DURATION_VALIDATION,
  workType: WORK_TYPE_VALIDATION,
  unemploymentDuration: UNEMPLOYMENT_DURATION_VALIDATION,
  degreeType: DEGREE_TYPE_VALIDATION,
  institution: INSTITUTION_VALIDATION,
  fieldOfStudy: FIELD_OF_STUDY_VALIDATION,
  jobCount: JOB_COUNT_VALIDATION,
  additionalIncomeSources: ADDITIONAL_INCOME_SOURCES_VALIDATION,
  bnplFrequency: BNPL_FREQUENCY_VALIDATION,
  bnplPurchaseType: BNPL_PURCHASE_TYPE_VALIDATION,
  bnplLatePayments: BNPL_LATE_PAYMENTS_VALIDATION,
  totalAnnualIncome: INCOME_VALIDATION,
  accounts: ACCOUNT_VALIDATION,
  totalAccountBalance: ACCOUNT_BALANCE_VALIDATION,
  cashAdvance: CASH_ADVANCE_VALIDATION,
  recentApplications: RECENT_APPLICATIONS_VALIDATION,
  recentAccountsOpened: RECENT_ACCOUNTS_OPENED_VALIDATION,
  creditRepair: CREDIT_REPAIR_VALIDATION,
  educationLevel: EDUCATION_LEVEL_VALIDATION,
  educationFieldOfStudy: EDUCATION_FIELD_OF_STUDY_VALIDATION,
  emails: EMAILS_VALIDATION,
  phoneNumber: PHONE_NUMBER_VALIDATION,
  communicationConsent: CONSENT_VALIDATION,
  contactConsent: CONSENT_VALIDATION,
  generalAddress: GENERIC_VALIDATION,
  suggestions: SUGGESTION_VALIDATION,
  paperlessStatements: STATEMENT_VALIDATION,
  creditProtection: CREDIT_PROTECTION_VALIDATION,
})

export const singlePageSchema = schema.extend({
  creditPullConsent: CREDIT_PULL_CONSENT_VALIDATION,
})

export const singlePageMCSchema = schema.extend({
  emails: EMAIL_MC_VALIDATION,
  creditPullConsent: CREDIT_PULL_CONSENT_VALIDATION,
})

export const approvedToApplySchema = z.object({
  paperlessStatements: STATEMENT_VALIDATION,
  creditProtection: CREDIT_PROTECTION_VALIDATION,
  agreements: CONSENT_VALIDATION,
})

export const lineSelectionSchema = z.object({
  lineSelection: z.string({ required_error: 'Line selection is required' }).min(1),
})

export {
  accountBalanceRefinement,
  employmentDetailRefinement,
  selfEmploymentDetailRefinement,
  unemploymentDetailRefinement,
  studentDetailRefinement,
  jobCountAndIncomeRefinement,
  bnplRefinement,
  recentApplicationsRefinement,
  recentAccountsOpenedRefinement,
  creditRepairRefinement,
  educationRefinement,
}
export type FormValues = z.infer<typeof schema>
export type SinglePageFormValues = z.infer<typeof singlePageSchema>
export type ApprovedToApplyFormValues = z.infer<typeof approvedToApplySchema>
export type LineSelectionFormValues = z.infer<typeof lineSelectionSchema>
export default schema
